import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { MASCOT_URL } from "../components/flux/Decor";
import { useAuth, API, storeSessionToken } from "../context/AuthContext";

// Module-level guard: survives React StrictMode unmount/remount cycles.
// The OAuth session_id is one-time use — the exchange must fire exactly once.
let exchangeState = { started: false, promise: null };

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }

    if (!exchangeState.started) {
      exchangeState.started = true;
      exchangeState.promise = axios.post(`${API}/auth/session`, { session_id: match[1] });
    }

    let cancelled = false;
    exchangeState.promise
      .then((res) => {
        if (cancelled) return;
        storeSessionToken(res.data.session_token);
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/matrix", { state: { user: res.data } });
      })
      .catch(async (err) => {
        if (cancelled) return;
        console.error("Session exchange failed:", err?.response?.status, err?.response?.data);
        // Recovery: a previous attempt may have already established the session
        try {
          const me = await axios.get(`${API}/auth/me`);
          setUser(me.data);
          window.history.replaceState(null, "", window.location.pathname);
          navigate("/matrix");
        } catch {
          exchangeState = { started: false, promise: null };
          navigate("/login");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0f1729] flex flex-col items-center justify-center gap-4" data-testid="auth-callback-page">
      <img src={MASCOT_URL} alt="Professor Flux" className="w-28 h-28 object-contain animate-float" />
      <p className="text-[#f59e0b] font-mono text-xs animate-blink">Calibrating your temporal credentials...</p>
    </div>
  );
}
